import { ResultBookjacket } from "../ResultBookJacket";
import { ResourceView } from "@tlc/ls2pac/dto/ResourceView";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";
import * as React from "react";
import { Link } from "@mui/material";

export const LSResultItemBookjacket = ({
  resource,
}: {
  resource: ResourceView | ResourceDWR;
}) => {
  if (!resource) {
    return null;
  }
  // TODO rename ResultBookjacket to something more generic
  return (
    <Link href={`#section=resource&resourceId=${resource.id}`}>
      <ResultBookjacket
        sx={{ margin: "0 auto" }}
        resource={resource}
        width={132}
        height={200}
      />
    </Link>
  );
};
